export { default, getStaticProps } from 'containers/InsightsPage/InsightsPage';
